<div class="row mb-2" *transloco="let t">


  <nav class="navbar navbar-expand-lg bg-body-tertiary bg-light" data-bs-theme="dark">
    <div class="container-fluid">
      <a class="navbar-brand"  routerLink="/reports/worker-reports">{{ t('Reports:') }}</a>
      <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="navbar-collapse" id="navbarNavDropdown">
        <ul class="navbar-nav">
          <li class="nav-item">
            <a class="nav-link active" aria-current="page"   routerLink="/reports/worker-reports">{{ t('Reports Home') }}</a>
          </li>
          <li class="nav-item dropdown">
            <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
              {{ t('Worker Reports') }}
            </a>
            <ul class="dropdown-menu">
             <li><a class="dropdown-item"  routerLink="/reports/worker-reports/worker-stats">{{ t('Actions Stats') }}</a></li>
             <li><a class="dropdown-item"  routerLink="/reports/worker-reports/location-settings">{{ t('Location Settings') }}</a></li>
             <li><a class="dropdown-item"  routerLink="/reports/worker-reports/worker-app-not-activated">{{ t('App Not Activated') }}</a></li>
             <li><a class="dropdown-item"  routerLink="/reports/worker-reports/worker-daily-group-count">{{ t('Group Count') }}</a></li>
             <li><a class="dropdown-item" *ngIf="okService.isAdmin()"  routerLink="/reports/worker-reports/worker-escalation-list">{{ t('Escalation List') }}</a></li>
             <li><a class="dropdown-item" *ngIf="okService.isAdmin()"  routerLink="/reports/worker-reports/worker-alert-loops">{{ t('Alert Loops') }}</a></li>
             <li><a class="dropdown-item"  routerLink="/reports/worker-reports/worker-no-location">{{ t('No Location Available') }}</a></li>
              @if(okService.hasFeature('mandown')){
              <li><a class="dropdown-item"  routerLink="/reports/worker-reports/worker-mandown">{{ t('Man Down Settings') }}</a></li>
              }
              @if(okService.hasFeature('fall_detection')){
              <li><a class="dropdown-item"  routerLink="/reports/worker-reports/worker-falldetection">{{ t('Fall Detection Settings') }}</a></li>
              }
              <li><a class="dropdown-item"  routerLink="/reports/worker-reports/last-sync">{{ t('Last Sync') }}</a></li>
              <li><a class="dropdown-item"  routerLink="/reports/worker-reports/permissions">{{ t('Worker Permissions') }}</a></li>
              @if(okService.hasFeature('app_connectivity')){
              <li><a class="dropdown-item"  routerLink="/reports/worker-reports/app-connectivity">{{ t('Worker Connectivity View') }}</a></li>
              }
            </ul>
          </li>
          <li class="nav-item dropdown">
            <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
              {{ t('Shift Reports') }}
            </a>
            <ul class="dropdown-menu">
             <li><a class="dropdown-item"  routerLink="/reports/worker-reports/worker-status">{{ t('Current Status') }}</a></li>
             <li><a class="dropdown-item" *ngIf="okService.isAdmin()"  routerLink="/reports/timesheets">{{ t('Timesheets') }}</a></li>
             <li><a class="dropdown-item"  routerLink="/reports/worker-reports/worker-has-started-shift">{{ t('Has Started a Shift') }}</a></li>
             <li><a class="dropdown-item"  routerLink="/reports/worker-reports/worker-no-shift-started">{{ t('No Shift Started') }}</a></li>
             <li><a class="dropdown-item"  routerLink="/reports/worker-reports/worker-last-shift-started">{{ t('Last Shift Started') }}</a></li>
             <li><a class="dropdown-item"  routerLink="/reports/worker-reports/worker-short-shift">{{ t('Short Shifts') }}</a></li>
             <li><a class="dropdown-item"  routerLink="/reports/worker-reports/start-end-shifts">{{ t('Scheduled Start/End Shifts Count') }}</a></li>
             <li><a class="dropdown-item" *ngIf="okService.isAdmin()"  routerLink="/reports/worker-reports/worker-end-shift">{{ t('End Worker Shifts') }}</a></li>
            </ul>
          </li>
          <li class="nav-item dropdown">
            <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
              {{ t('Monitor Reports') }}
            </a>
            <ul class="dropdown-menu">
             <li><a class="dropdown-item"  routerLink="/reports/worker-reports/monitor-assignment-summary">{{ t('Monitor Assignment Summary') }}</a></li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</div>
